import { IGreenWaveDisplay } from "@types"
import { protectedApi } from "store/Api"


export interface IGreenWaveDisplayArgs {
    serverId: number | null
    begin: string
    timespan: number
    greenBand: boolean
}


const greenWaveDisplayApi = protectedApi.injectEndpoints({

    endpoints: (builder) => ({
        greenWaveDisplay: builder.query<IGreenWaveDisplay[], void>({
            query: () => {
                return {
                    method: "GET",
                    url: `data/green_wave_display`,
                }
            },
        }),
        greenWaveDisplayPost: builder.mutation<IGreenWaveDisplay[], IGreenWaveDisplayArgs>({

            query: (data) => {
                return {
                    method: "POST",
                    url: `data/green_wave_display`,
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: data,
                }
            },
        }),
    }),


})

export const { useGreenWaveDisplayQuery, useGreenWaveDisplayPostMutation } = greenWaveDisplayApi
